import {
  DataGridDateRangeFilter,
  DataGridFilter,
  DataGridFilters,
  DataGridOptions,
} from "fe-shared/src/components/DataGrid/modules/types";
import {
  DataGridFiltersParams,
  DataGridRequestParams,
  GridInvoice,
  GridInvoiceList,
} from "../types";

const getDateRangeFilterValues = (filter: DataGridDateRangeFilter) => {
  const [startDate, endDate] = filter.value;

  if (startDate) {
    return [startDate, endDate || startDate]
      .map((date) => new Date(date).toJSON())
      .join(",");
  }
  return "";
};

const getFilterValues = (filter: DataGridFilter) => {
  switch (filter.type) {
    case "dateRangeFilter":
      return getDateRangeFilterValues(filter);
    case "selectFilter":
      return filter.value.length ? filter.value.join(",") : "";
    default:
      return filter.value;
  }
};

const FILTER_CONVERTERS_MAP: {
  [key: string]: (
    propertyName: string,
    values: string
  ) => DataGridFiltersParams[];
} = {
  invoiceNumber: (propertyName, values) => [
    {
      propertyName,
      values: values.replace(/[# ]/g, ""),
    },
  ],
  sum: (propertyName, values) =>
    values.split(",").map((sum, index) => ({
      propertyName: index ? "maxInvoiceSum" : "minInvoiceSum",
      values: sum,
    })),
};

const getFilteringParameters = (filters: DataGridFilters) => {
  const filteringParameters: DataGridFiltersParams[] = [];

  Object.entries(filters).forEach(([propertyName, filter]) => {
    const values = getFilterValues(filter);

    if (values) {
      const filterConverter = FILTER_CONVERTERS_MAP[propertyName];
      const newFilteringParameters = filterConverter
        ? filterConverter(propertyName, values)
        : [{ propertyName, values }];

      filteringParameters.push(...newFilteringParameters);
    }
  });

  return filteringParameters;
};

export const getInvoicesRequestParams = (
  filters: DataGridFilters,
  options: DataGridOptions
): DataGridRequestParams => {
  return {
    filteringParameters: getFilteringParameters(filters),
    sortingBy: {
      propertyName: options.sortField,
      isAscending: options.sortDirection === "asc",
    },
  };
};

export const getFlattenedInvoices = (data?: GridInvoiceList<GridInvoice>[]) =>
  data?.reduce(
    (acc: GridInvoice[], element: GridInvoiceList<GridInvoice>) =>
      acc.concat(element.invoices),
    []
  );
